import { render, staticRenderFns } from "./campusDetail.vue?vue&type=template&id=7ccd2bfb&scoped=true"
import script from "./campusDetail.vue?vue&type=script&lang=js"
export * from "./campusDetail.vue?vue&type=script&lang=js"
import style1 from "./campusDetail.vue?vue&type=style&index=1&id=7ccd2bfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccd2bfb",
  null
  
)

export default component.exports